import React, { createContext, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { showSuccessToast } from '../helpers/SweetAlert';
import { loginStateReset } from '../redux/slices/Auth/LoginSlice';
import { logoutStateReset } from '../redux/slices/Auth/LogoutSlice';
import { GetProductsAddedToCartApi } from '../redux/actions/Cart/GetProductsAddedToCartAction';
import { clearCart, setCartItems } from '../redux/slices/Cart/CartSlice';
import { markItemAsAdded, resetAddedToCart, setShowCartButtons } from '../redux/slices/Cart/CartUISlice';
import { GetProfileAPI } from '../redux/actions/Profile/GetProfileAction';
import { GetUsersDataAPI } from '../redux/actions/Dashboard/userDataAction';
import { OrdersForSuppliersAPI } from '../redux/actions/Dashboard/ordersForSuppliersAction';
import { SuppliersOrdersAPI } from '../redux/actions/Dashboard/supplierOrdersAction';
import { GetUsersCountAPI } from '../redux/actions/Dashboard/usersCountAction';
import { GetNotificationApi } from '../redux/actions/Notification/GetNotificationAction';
import { GetProductTypeApi } from '../redux/actions/Supplier/GetProductTypeAction';

// import { GetProfileAPI } from '../redux/actions/profile/getProfileAction';
// import { GetUsersDataAPI } from '../redux/actions/dashboard/userDataAction';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const dispatch = useDispatch();
    const { response: cartItemsFromBackend } = useSelector((state) => state.productsAddedToCart);
    const cartItems = useSelector((state) => state.cart.items);
    const cartLoaded = useSelector((state) => state.cart.loaded);

    const [isAuthenticated, setIsAuthenticated] = useState(() => {
        const token = localStorage.getItem('authToken');
        return token ? true : false;
    });

    const login = (token) => {
        localStorage.setItem('authToken', token);
        setIsAuthenticated(true);
    };

    const logout = () => {
        localStorage.removeItem('authToken');
        // localStorage.removeItem("cartFetchedOnce");
        setIsAuthenticated(false);
        showSuccessToast('Logged out successful!');
        dispatch(logoutStateReset());
        dispatch(loginStateReset());
        dispatch(clearCart());
        dispatch(resetAddedToCart());
        dispatch(setShowCartButtons(false));
    };

    const fetchProfile = async () => {
        try {
            await dispatch(GetProfileAPI());
            // await dispatch(GetUsersDataAPI());
        } catch (error) {
            console.error("Failed to fetch profile:", error);
        }
    };

    const fetchNotifications = async () => {
        try {
            await dispatch(GetNotificationApi());
        } catch (error) {
            console.error("Failed to fetch notifications:", error);
        }
    }

    const fetchProductType = async () => {
        try {
            await dispatch(GetProductTypeApi());
        } catch (error) {
            console.error("Failed to fetch notifications:", error);
        }
    }

    const fetchDashboardData = async () => {
        try {
            await dispatch(GetUsersDataAPI());
            await dispatch(OrdersForSuppliersAPI());
            await dispatch(SuppliersOrdersAPI());
            await dispatch(GetUsersCountAPI());
        } catch (error) {
            console.error("Failed to fetch dashboard data:", error);
        }
    }

    const fetchCartProducts = async () => {
        try {
            await dispatch(GetProductsAddedToCartApi())
        } catch (error) {

        }
    }

    useEffect(() => {
        if (isAuthenticated && !cartLoaded) {
            fetchCartProducts();
        }
        if (isAuthenticated) {
            fetchProfile();
            fetchDashboardData();
            fetchProductType()
            // fetchNotifications()
        }
    }, [isAuthenticated, cartLoaded]);

    useEffect(() => {
        if (cartItemsFromBackend?.data?.length > 0 && !cartLoaded) {
            dispatch(setShowCartButtons(true));
            dispatch(setCartItems(cartItemsFromBackend.data));
            cartItemsFromBackend.data.forEach(item => {
                dispatch(markItemAsAdded(item._id)); // Update UI state if needed
            });
        }
    }, [cartItemsFromBackend, cartItems]);

    useEffect(() => {
        let intervalId;

        if (isAuthenticated) {
            // Call immediately once
            fetchNotifications();

            // Then call every 5 seconds
            intervalId = setInterval(() => {
                fetchNotifications();
            }, 5000);
        }

        return () => {
            clearInterval(intervalId); // Clear interval when component unmounts or isAuthenticated changes
        };
    }, [isAuthenticated]);

    useEffect(() => {
        const checkAuth = () => {
            const token = localStorage.getItem('authToken');
            if (token) {
                setIsAuthenticated(true)
            } else {
                setIsAuthenticated(false)
            }
        };
        checkAuth();
    }, []);

    return (
        <AuthContext.Provider value={{ isAuthenticated, login, logout, fetchCartProducts, fetchProfile, fetchProductType, fetchDashboardData }}>
            {children}
        </AuthContext.Provider>
    );
};
